import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TransaccionService } from '../../shared/servicios/transaccion.service';

@Component({
  selector: 'app-final-transaccion',
  templateUrl: './final-transaccion.component.html',
  styleUrls: ['./final-transaccion.component.scss']
})
export class FinalTransaccionComponent implements OnInit {

  tipo;
  referencia;
  detailStatus;
  muestraSpinner: boolean = true;
  muestraResultado: boolean = false;
  muestraError: boolean = false;

  constructor(private route: ActivatedRoute, private transaccionService: TransaccionService) {
    // guia o recarga
    this.tipo = this.route.snapshot.paramMap.get('tipo');
    // referencia
    this.referencia = this.route.snapshot.paramMap.get('referencia');

    this.transaccionService.getStatus(this.tipo, this.referencia).subscribe((data) => {
      this.detailStatus = data[0];
      this.muestraSpinner = false;
      this.muestraResultado = true;
      // console.log(data)
    }, err => {
      this.muestraSpinner = false;
      this.muestraError = true;
      // console.log('error')
    });
    // console.log(this.tipo, this.referencia)
  }

  ngOnInit(): void {
  }

}
